import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { fetchKillHistoryEntries } from "@/helper/killHistory";
import { ProfileNames } from "@/types/ProfileName";
import { KillHistoryEntry } from "@/types/KillHistoryEntry";

export interface KillHistoryState {
  entries: KillHistoryEntry[];
  isLoading: boolean;
  error: string | null;
}

const initialState: KillHistoryState = {
  entries: [],
  isLoading: false,
  error: null,
};

export const loadKillHistoryAction = createAsyncThunk(
  "killHistory/loadKillHistory",
  async (profileNames: ProfileNames[]) => {
    return fetchKillHistoryEntries(profileNames);
  }
);

const killHistorySlice = createSlice({
  name: "killHistory",
  initialState,
  reducers: {
    clearKillHistory: (state) => {
      state.entries = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(loadKillHistoryAction.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(loadKillHistoryAction.fulfilled, (state, { payload }) => {
      state.isLoading = false;
      state.entries = payload;
    });
    builder.addCase(loadKillHistoryAction.rejected, (state, { error }) => {
      state.isLoading = false;
      state.error = error.message ?? "Failed to load kill history";
      state.entries = [];
    });
  },
});

export const { clearKillHistory } = killHistorySlice.actions;

export default killHistorySlice.reducer;
